export const initialContext = {
  info: {
    stores: [],
    address: {
      country: {
        code: '',
      },
    },
    allows_unified_dashboard: false,
    requires_activation: false,
    status: '',
    trial_period_date: null,
    name: '',
    logo_url: '',
    reject_reasons: [],
    filters: null,
    billingFilters: null,
    billingDetailFilters: null,
    selectedStore: {
      id: '',
      provider: '',
      currency: '',
      preferences: {
        return_reasons: [],
        allows_unified_flow: false,
        allows_shipments: false,
        allows_outbound: false,
        shipping_skip_packing: false,
        allows_compliance_hub: false,
      },
      num_unread_notifications: 0,
      timezone: '',
      returns_portal_url: '',
    },
    selectedReturnPortal: {
      id: '',
      name: '',
      slug: '',
      theme: {},
      preferences: {},
    },
    returnPortals: [],
    subscription_plan: '',
    has_delivery_methods: false,
    support_dashboard_url: '',
    transactions: { results: [], next: null, previous: null, count: 0 },
    deliveryMethods: [],
    userInfo: {
      id: '',
      email: '',
      first_name: '',
      last_name: '',
      full_name: '',
      username: '',
      has_usable_password: false,
      is_owner: false,
    },
    systemAlerts: [],
  },
}
